(function (window) {
  var FULL_REASONS = ["unreviewed_action", "protected_journey", "invalid_configuration", "full_capture"];

  window.posthogCapturePolicy = {
    apply: function (event, policy) {
      if (!event || event.event !== "$pageview") return event;
      try {
        if (!policy || policy.version !== "v1" || typeof policy.action !== "string" ||
          !/^[a-z][a-z0-9_]*(\/[a-z][a-z0-9_]*)*#[a-z][a-z0-9_]*$/.test(policy.action) ||
          typeof policy.pageleave !== "boolean") return event;
        var rule = policy.pageview;
        if (!rule || typeof rule.rate !== "number" || !isFinite(rule.rate) || rule.rate < 0 || rule.rate > 1) return event;
        var sampled = rule.strategy === "session_sample" && rule.reason === "audited_action";
        var full = rule.strategy === "full" && rule.rate === 1 && FULL_REASONS.indexOf(rule.reason) !== -1;
        if ((!sampled && !full) || (sampled && policy.pageleave === true)) return event;
        var properties = event.properties;
        if (!properties || typeof properties !== "object" || Array.isArray(properties)) return event;
        var rate = rule.rate;
        var reason = rule.reason;
        if (sampled) {
          var sessionId = properties.$session_id;
          if (typeof sessionId !== "string" || sessionId.trim() === "") {
            rate = 1;
            reason = "missing_session";
          } else {
            var keep = window.posthogPerformance.sampled(sessionId, rate);
            if (keep === false) return null;
            if (keep !== true) return event;
          }
        }
        properties.capture_policy_version = "v1";
        properties.pageview_sample_rate = rate;
        properties.pageview_capture_reason = reason;
        return event;
      } catch (_error) {
        return event;
      }
    }
  };
})(window);
